import { render, staticRenderFns } from "./forage.vue?vue&type=template&id=c3efc3f4&scoped=true&"
import script from "./forage.vue?vue&type=script&lang=js&"
export * from "./forage.vue?vue&type=script&lang=js&"
import style0 from "./forage.vue?vue&type=style&index=0&id=c3efc3f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3efc3f4",
  null
  
)

export default component.exports